import { useAuth } from '../contexts/AuthContext';
import { isOwnOrder, OwnableOrder } from '../utils/customerAccess';

export function useOwnOrderAccess(
  order: OwnableOrder | null | undefined,
  options: { loading?: boolean; error?: Error | null } = {}
) {
  const { loading: authLoading, isCustomerPortalUser, user } = useAuth();
  const { loading = false, error = null } = options;

  if (authLoading || loading) {
    return { ready: false, denied: false };
  }

  if (!isCustomerPortalUser()) {
    return { ready: true, denied: false };
  }

  if (error || !order || !isOwnOrder(order, user)) {
    return { ready: true, denied: true };
  }

  return { ready: true, denied: false };
}
